// ** Initial State
const initialState = {
    tasks: [],
    filteredTasks: [],
    selectedTask: {},
    loading: true,
    params: {
      filter: '',
      query: '',
      sort: '',
      tag: '',
    }
  }
  
  const TodoReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_TASKS':
        return { ...state, tasks: action.tasks, filteredTasks: action.filteredTasks, params: action.params, loading: false }
      case 'SORTING':
        return { ...state, filteredTasks: action.tasks, params: action.params }
      case 'LOADING':
        return { ...state, loading: action.loading }
      case 'FILTERING':
        return { ...state, filteredTasks: action.filteredTasks, params: action.params }
      case 'SEARCHING':
        return { ...state, filteredTasks: action.filteredTasks, params: action.params }
      case 'TAGS':
        return { ...state, params: action.params }
      case 'TRASH':
          return { ...state, task: action.tasks }
      default:
        return state
    }
  }
  export default TodoReducer
  